import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Affix, Alert, Button, Card, Layout, Space, Spin } from 'antd';
import { Routes } from '../../routes';
import { PageHeader } from '@ant-design/pro-layout';
import { buildPageHeaderBreadcrumb } from '../../updated/utils';
import { useCertificateQuery, useCertificateOverridesQuery } from '../../gql/hooks/queries';
import EditCertificateForm from './EditCertificateForm';
import './styles.less';

const EditCertificate = ( props ) => {
    const editFormRef = useRef( null );
    const [ certificateId ] = useState( props?.route?.params?.certificateId ); 
    const [ isSaving ] = useState( false );

    /*************************************
     *  ANCHOR Load Overrides
     *************************************/

    const { 
        fetch: fetchCertificateOverrides, 
        data: certificateOverridesData, 
        loading: certificateOverridesLoading, 
        error: certificateOverridesError, 
        called: certificateOverridesCalled 
    } = useCertificateOverridesQuery( certificateId, { fetchPolicy: 'network-only' } );
    
    useEffect( () => {
        if ( certificateId ) {
            fetchCertificateOverrides();
        }
    }, [ certificateId ] );

    const certificateOverrides = useMemo( () => {
        if ( certificateOverridesData && !certificateOverridesError ) {
            return [ ...certificateOverridesData.certificateTemplate.node.certificateTemplateOverrides ]
                .map( i => ( { ...i, preview: i.certificateTemplateOverrideUrl } ) );
        } else {
            return undefined;
        }
    }, [ certificateOverridesData, certificateOverridesError ] );

    /*************************************
     *  ANCHOR Load Certificate
     *************************************/
 
    const { 
        fetch: fetchCertificate, 
        data: certificateData, 
        loading: certificateLoading, 
        error: certificateError, 
        called: certificateCalled 
    } = useCertificateQuery( certificateId, { fetchPolicy: 'network-only' } );
    
    useEffect( () => {
        if ( certificateId ) {
            fetchCertificate();
        }
    }, [ certificateId ] );

    const certificate = useMemo( () => {
        if ( certificateData && !certificateError ) {
            return { ...certificateData.certificateTemplate.node };
        } else {
            return undefined;
        }
    }, [ certificateData, certificateError ] );

    const addCertificateCallback = () => {
        fetchCertificateOverrides();
    };

    /*************************************
     *  ANCHOR Save Certificate
     *************************************/
    
    const saveCertificate = ( values ) => {
        editFormRef.current.setSaving( false );
    };

    /*************************************
     *  ANCHOR State Handlers
     *************************************/
 
    const isLoading = useMemo( () => !certificateCalled || !certificateOverridesCalled || certificateLoading || 
        certificateOverridesLoading, 
    [ certificateLoading, certificateCalled, certificateOverridesLoading, 
        certificateOverridesCalled ] );

    const hasError = useMemo( () => certificateError || certificateOverridesError, 
        [ certificateError, certificateOverridesError ] );
    
    /*************************************
     *  ANCHOR Render
     *************************************/
 
    return (
        <Layout className="edit-certificate-view">
            <Layout>
                { /* Breadcrumbs */ }
                <PageHeader
                    breadcrumb={ buildPageHeaderBreadcrumb( [
                        { breadcrumbName: 'Course Studio', path: Routes.Home.buildPath() },
                        { breadcrumbName: 'Incentives', path: Routes.GamificationNav.buildPath() },
                        { breadcrumbName: 'Certificates', path: Routes.ListCertificates.buildPath() },
                        { breadcrumbName: 'Edit' }
                    ] ) } 
                />

                { /* Loading Spinner */ }
                { isLoading &&
                <Spin size="medium"/>
                }

                { /* Main Content */ }
                { !isLoading && 
                <Card
                    className="content"
                    title={ certificate ? `${ certificate.name } Overrides` : 'Edit Certificate' }
                > 
                    { /* Error Alert */ }
                    { hasError &&
                        <Alert 
                            type="error"
                            message="Error"
                            description="An unknown error occurred. Please try again later."
                        />
                    }

                    { /* Edit Form */ }
                    { !hasError && certificate &&
                        <EditCertificateForm 
                            ref={ editFormRef }
                            certificate={ certificate }
                            certificateOverrides={ certificateOverrides }
                            saveCertificateCallback={ saveCertificate }
                            addCertificateCallback={ addCertificateCallback }
                        />
                    }
                </Card> 
                } 
            </Layout>

            { /* Right side button bar */ }
            { !isLoading && !hasError &&
            <Layout.Sider 
                className="side-action-bar" 
                width={ 100 } 
            >   
                <Affix offsetTop={ 95 }> 
                    <Space 
                        direction="vertical" 
                        size={ 16 } 
                    >     
                       
                        <Button
                            disabled={ isSaving } 
                            onClick={ () => window.history.back() }
                        >
                            Back
                        </Button>
                    </Space> 
                </Affix>
            </Layout.Sider>
            }
        </Layout>
    );
};

export default EditCertificate;

//  /*************************************
//  *  ANCHOR Load Brands
//  *************************************/
    
//  const { data: brandsData, loading: brandsLoading, error: brandsError } = 
//  useBrandsQuery( { fetchPolicy: 'network-only' } );
 
// const brands = useMemo( () => {
//  if ( brandsData && !brandsLoading ) {
//      return brandsData.brands.edges.map( edge => edge.node );
//  } else {
//      return [];
//  }
// }, [ brandsData, brandsLoading ] );

// /*************************************
// *  ANCHOR Load Profiles
// *************************************/
 
// const { data: profilesData, loading: profilesLoading, error: profilesError } = 
//  useProfilesQuery( { fetchPolicy: 'network-only' } );
 
// useEffect( () => {
//  if ( profilesData && !profilesLoading ) {
//      setProfiles( profilesData.certificateProfiles.edges.map( edge => edge.node ) );
//  } else {
//      setProfiles( [] );
//  }
// }, [ profilesData, profilesLoading ] );

